<template>
    <div>
      <SaveLinkForm/>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SaveLinkForm from "../../components/link/SaveLinkForm";

export default {
  name: "save-link",
  components: {
    SaveLinkForm
  },
  computed: {
    ...mapGetters([])
  },
};

</script>